import React, { useEffect } from 'react'

import * as S from './styles'
import { Image } from '@/components'
import { useIsVisibleElement } from '@/hooks'

export type BlogPostHeaderProps = {
  /**
   * Image url of the header article
   *
   * @example
   * ```tsx
   * <BlogPostHeader imageSrc="https://picsum.photos/200/300" />
   * ```
   *
   */
  imageSrc: string

  /**
   * Image alt of the header article
   *
   * @example
   * ```tsx
   * <BlogPostHeader imageAlt="Alt da imagem" />
   * ```
   *
   * @default ""
   */
  imageAlt?: string

  /**
   * Image name of the header article
   *
   * @example
   * ```tsx
   * <BlogPostHeader imageName="image-name" />
   * ```
   *
   */
  imageName?: string
}

export const BlogPostHeader: React.FC<BlogPostHeaderProps> = ({
  imageSrc,
  imageAlt = '',
  imageName,
}) => {
  const { element } = useIsVisibleElement()

  useEffect(() => {
    const handleScroll = () => {
      if (element.current) {
        const image = element.current.firstChild as HTMLImageElement
        image.style.transform = `translate3d(0, -${
          window.scrollY / 100
        }%, 0) scale(${(100 + window.scrollY / 5) / 100})`
      }
    }

    document.addEventListener('scroll', handleScroll)

    return () => document.removeEventListener('scroll', handleScroll)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <S.HeaderContainer>
      <div className="container-img" ref={element}>
        <Image
          src={imageSrc}
          alt={imageAlt}
          fileName={imageName}
          fill
          style={{ objectFit: 'cover' }}
          priority
        />
      </div>
    </S.HeaderContainer>
  )
}
